<template>
	<div>
		<el-card class="box-card">
			<el-form label-width="80px">
				<el-form-item label="类型:">
					<el-radio-group v-model="listQuery.search.type" @change="typeChange">
						<el-radio label="" border>全部</el-radio>
						<el-radio label="1" border>我投诉的</el-radio>
						<el-radio label="2" border>投诉我的</el-radio>
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="状态:">
					<el-radio-group v-model="listQuery.search.state" @change="stateChange">
						<el-radio label="" border>全部</el-radio>
						</el-radio>
						<el-radio :label="item.value.toString()" v-for="item in state_list" border>{{item.label}}
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="">
					<el-row :gutter="5">
						<el-col :span="3">
							<el-input v-model="listQuery.search.order_id" placeholder="请输入订单ID"></el-input>
						</el-col>

						<el-col :span="3">
							<el-button type="primary" icon="el-icon-search" @click="keySearch">搜索</el-button>
						</el-col>
					</el-row>
				</el-form-item>
			</el-form>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" inline class="demo-table-expand">
							<el-form-item label="反馈内容:">
								<span>{{props.row.feedback}}</span>
							</el-form-item>
							<el-form-item label="反馈时间:">
								<span>{{ props.row.handle_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
							</el-form-item>
						</el-form>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="id" label="ID"> </el-table-column> -->
				<el-table-column prop="create_time" label="投诉时间">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="order_id" label="订单ID"></el-table-column>
				<el-table-column prop="uid_name" label="投诉用户"></el-table-column>
				<el-table-column prop="to_uid_name" label="被投诉用户"></el-table-column>
				<el-table-column prop="cause" label="投诉内容"></el-table-column>
				<el-table-column label="投诉状态">
					<template slot-scope="{row}">
						<el-tag :type="row.state_color">
							{{ row.state_init}}
						</el-tag>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
		</div>
	</div>
</template>

<script>
	import {
		complainListInit,
		complainList,
	} from '@/api/jd_task'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	export default {
		components: {
			Pagination,
			Dtp
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				state_list: [],
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.getListInit();
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						type: '',
						state: '',
						order_id: '',
					},
				}
			},
			getListInit() { // 获取列表页的其他数据
				complainListInit(Qs.stringify()).then(response => {
					this.state_list = response.result.state;
				})
			},
			getList() { // 获取列表数据
				this.loading = true;
				complainList(Qs.stringify(this.listQuery)).then(response => {
					this.data_list = response.result.items;
					this.total = response.result.total;
					this.loading = false;
				})
			},
			typeChange() {
				this.keySearch();
			},
			stateChange() {
				this.keySearch();
			},
		},
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>
